import * as React from 'react';
 

 
class ItemSlider extends React.Component {

 

    static defaultProps = {
        visibleItems: 4,
        isInfinite: true,
        delay: 5000,
    }

    state = {
        images: [],
        currentPosition: 0,
        interval: null,
        visibleItems: this.props.visibleItems,
        isInfinite: this.props.isInfinite,
        totalItems: this.props.images.length,
        width:window.innerWidth
    };

    constructor(props){
        super(props);
        this.setDimension();
        this.autoScroll();
        window.addEventListener('resize',this.setDimension);
        
        
         

    }
    componentWillUnmount(){
        window.removeEventListener('resize',this.setDimension);
    }
    setDimension=()=>{
 
        if(window.innerWidth<720  && window.innerWidth>420 ){
            
            this.setState({ visibleItems:2 });
        }
        else if(window.innerWidth>720  && window.innerWidth<920 ){
            
            this.setState({ visibleItems:3 });
        }
        else if ( window.innerWidth<420) {
         
            this.setState({ visibleItems:1 });
        }
        
        else{
      
            this.setState({ visibleItems:4 });
        }

    }
    componentWillUpdate(nextProps, nextState) {
        if (this.state.currentPosition !== nextState.currentPosition) {
            this.setDimension();
            this.animate();
        }
    }

    autoScroll(){
        setTimeout(()=>{
            this.scrollRight()
        })
    }

    scrollLeft = () => {
        const currentPosition = this.updatePosition(this.state.currentPosition - 1);
        this.setState({ currentPosition });
    }

    scrollRight = () => {
        const currentPosition = this.updatePosition(this.state.currentPosition + 1);
        this.setState({ currentPosition });
    }

    setVisibleItems = (currentVisibleItems) => {
        const container = document.querySelector('.rsc-slider') ;

        const visibleItems = (container && container.offsetWidth < 720) ? 1 : currentVisibleItems;
        this.setState({ visibleItems });
    }

    sliderStyle = (classname) => {
        const items = document.querySelector(classname);
        const itemWidth = items ? items.offsetWidth : 0;
        const shift = itemWidth * this.state.currentPosition;
        return { transform: `translateX(-${shift}px)` };
    }

    isOpaque = (key) => {
        const nextPosition = this.props.visibleItems + this.state.currentPosition;
        const opaque = this.props.images.slice(this.state.currentPosition, nextPosition);
        return opaque.indexOf(this.props.images[key]) !== -1;
    }

    animate = () => {
        if (this.state.interval) {
            window.clearInterval(this.state.interval);
        }
        if (!this.props.delay) {
            return false;
        }
        const interval = window.setInterval(this.scrollRight, this.props.delay);
        this.setState({ interval });
    }

    clearAnimate = () => {
        if (this.state.interval) {
            clearInterval(this.state.interval);
            this.setState({ interval: null });
        }
    }

    updatePosition = (nextPosition) => {
        const { visibleItems, currentPosition } = this.state;
        // console.log(visibleItems, currentPosition, nextPosition);
        const skipScrollIfEnd = this.skipScrollIfEnd(visibleItems, currentPosition, nextPosition);
        const skipScrollIfNonInfinite = this.skipScrollIfNonInfinite(visibleItems, currentPosition, nextPosition);
        const scrollIfInfinite = this.scrollIfInfinite(visibleItems, currentPosition, nextPosition);
        const scrollToBeginningIfEnd = this.scrollToBeginningIfEnd(visibleItems, currentPosition, nextPosition);
        if (skipScrollIfEnd !== undefined) {
            return skipScrollIfEnd;
        }
        if (skipScrollIfNonInfinite !== undefined) {
            return skipScrollIfNonInfinite;
        }
        if (scrollIfInfinite !== undefined) {
            return scrollIfInfinite;
        }
        if (scrollToBeginningIfEnd !== undefined) {
            return scrollToBeginningIfEnd;
        }
        return nextPosition;
    }

    skipScrollIfNonInfinite = (visibleItems, currentPosition, nextPosition) => {

        if (!this.state.isInfinite && nextPosition < 0) {
            return currentPosition;
        }
    }

    scrollIfInfinite = (visibleItems, currentPosition, nextPosition) => {

        if (this.state.isInfinite && nextPosition < 0) {
            return nextPosition + visibleItems;
        }
    }

    scrollToBeginningIfEnd = (visibleItems, currentPosition, nextPosition) => {

        if (nextPosition + visibleItems > this.state.totalItems) {
            return 0;
        }
    }

    skipScrollIfEnd = (visibleItems, currentPosition, nextPosition) => {

        if (!this.state.isInfinite && nextPosition + visibleItems > this.state.totalItems) {
            return currentPosition;
        }
        if (!this.state.isInfinite && nextPosition < 0) {
            return currentPosition;
        }
    }

    render() {
    
        if(this.state.visibleItems<=0){
            return <></>;
        }
        const sliderStyle = this.sliderStyle('.rsc-slider-item');
        const imgWidth = 100 / this.state.visibleItems;

        const images = this.props.images.map((item, key) => ({
            itemClass: this.isOpaque(key) ? 'rsc-slider-item' : 'rsc-slider-item rsc-slider-item_transparent',
            src: <div key={key}>{item} </div>

        }));

        return (
            <div className="rsc-container">
                <div className="rsc-slider" style={sliderStyle}>
                    {images.map((item, key) =>
                        <div className={item.itemClass} key={key} style={{ 'flex': `0 0 ${imgWidth}%` }}>
                            <div className="rsc-slider-item-img">{item.src}</div>
                        </div>
                    )}
                </div>
                {images.length > this.state.visibleItems ?
                    <div>
                        <div className="rsc-navigation rsc-navigation_left rsc-arrow_left" onClick={this.scrollLeft}></div>
                        <div className="rsc-navigation rsc-navigation_right rsc-arrow_right" onClick={this.scrollRight}></div>
                    </div>
                    : null}
            </div>
        );
    }
}


export default ItemSlider;